module.exports = __webpack_public_path__ + "img/06_1_4_1.1e7e34ef.png";